import styled from "styled-components";


// export const DefaultStyle = createGlobalStyle`
//     *{
//     box-sizing: border-box;
//     font-family: inherit;
//     }
// `

export const WrapperRow = styled.div`
    border-top: 1px solid #C8C8C8;
    margin-top: 25.5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
    padding: 30px 0px 0px 0px;
`
export const WrapperLeftCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    flex-wrap: wrap;
    border-right: 1px solid #efefef;
    padding-right: ${props => props.styleProps.wrapperLeftColPadding};
    width: ${props => props.styleProps.wrapperLeftCol};
`
export const WrapperRightCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    flex-wrap: wrap;
    width: ${props => props.styleProps.wrapperRightCol};
    padding-left: ${props => props.styleProps.wrapperRightColPadding};
`





// WEBPACK FOOTER //
// ./src/estimate_list/components/list/bundleGroup/bundleGroup.style.js